<template>
  <wp-items-edit
    content-type="pages"
    content-type-singular="page"
    content-name="Pages"
    content-name-singular="Page"
  />
</template>

<script>
import WpItemsEdit from '@/views/wp-item/wp-items-edit/WpItemsEdit.vue'

export default {
  components: {
    WpItemsEdit,
  },
}
</script>

<style scoped>

</style>
